import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "comment_list_wrap" }
const _hoisted_2 = { class: "my_comment_wrap" }
const _hoisted_3 = { for: "my_comment" }
const _hoisted_4 = {
  key: 0,
  class: "custom_placeholder"
}
const _hoisted_5 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextEffect = _resolveComponent("TextEffect")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "comment_title" }, [
      _createElementVNode("p", null, "성매매 없는 세상을 위한"),
      _createElementVNode("p", null, "당신의 한마디를 남겨주세요")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      ($setup.state.isMobile)
        ? (_openBlock(), _createBlock(_component_TextEffect, {
            key: 0,
            list: $setup.state.commentList,
            "is-vertical": true
          }, null, 8, ["list"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_TextEffect, { list: $setup.firstList }, null, 8, ["list"]),
            _createVNode(_component_TextEffect, {
              list: $setup.secondList,
              isReverse: true
            }, null, 8, ["list"])
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _withDirectives(_createElementVNode("textarea", {
          name: "my_comment",
          id: "my_comment",
          minlength: "10",
          maxlength: "90",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.myComment) = $event))
        }, null, 512), [
          [_vModelText, $setup.state.myComment]
        ]),
        (!$setup.state.myComment)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" 나의 한마디를 남겨주세요 ", -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" (최소 10자, 최대 90자) ", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        id: "prev",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.prev && $setup.prev(...args)))
      }, "이전"),
      _createElementVNode("button", {
        id: "next",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
      }, "다음")
    ]),
    ($setup.modal.isShow)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: -1,
          title: $setup.modal.title,
          content: $setup.modal.content,
          onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.modal.isShow = false))
        }, null, 8, ["title", "content"]))
      : _createCommentVNode("", true)
  ], 64))
}